/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import AnalysisIcons from "../../../CommonUi/AnalysisIcons/AnalysisIcons";
import { COMPLIANCE_COLOR_CODES } from "../../../../services/config";
import Tooltip from "components/CommonUi/Tooltip/Tooltip";

type PositiveListProps = {
  analysis: any;
  show?: string;
};

type ComplianceCode = "-1" | "0" | "1" | "2" | "3";

const PositiveList: React.FC<PositiveListProps> = ({ analysis, show }) => {
  const responses = analysis?.response || analysis?.responses || [];

  const FIXED_ORDER = [
    "people",
    "living",
    "food",
    "mobility",
    "consumer",
    "happiness",
  ];

  const FR_IMAGES_MAPPING:any = {
    "people" :"personnes",
    "living": "espaces",
    "food": "alimentation",
    "mobility": "mobilité",
    "consumer": "produits",
    "happiness": "bonheur"
  };

  const containerStyle = css`
    display: flex;
    gap: 5px;
    align-items: center;
    flex-wrap: wrap;
  `;

  const wrapperClass = css`
    min-width: max-content;
  `;

  // STEP 1: Build a dictionary of domains with their colors
  const domainMap: Record<string, string> = {};

  const addDomain = (domainName: string, category: ComplianceCode | undefined) => {
    if (!domainName) return;

    let color = "#EAEEF0";
    if (category && ["-1", "0", "1", "2", "3"].includes(category.toString())) {
      color = COMPLIANCE_COLOR_CODES[category] || "#FFC400";
    }
    let _domainName = domainName.split(" ")?.[0]?.toLowerCase().replace(",","");
    domainMap[_domainName] = color;
  };

  // Parse the messy responses and fill domainMap
  responses.forEach((item: any) => {
    // Case 1 — single object
    if (item?.response && !Array.isArray(item.response)) {
      addDomain(item.response.domain_name, item.response.domain_category);
    }

    // Case 2 — array
    if (Array.isArray(item?.response)) {
      item.response.forEach((domainItem: any) => {
        domainItem?.domains?.forEach((d: any) => {
          addDomain(d.domain_name, d.category);
        });
      });
    }
  });

  return (
    <div css={containerStyle}>
      {FIXED_ORDER.map((domain) => {
        const exists = domainMap[domain] || domainMap[FR_IMAGES_MAPPING[domain]];
        const color = exists || "#EAEEF0";

        return (
          <div
            key={domain}
            css={css`
              visibility: ${exists ? "visible" : "hidden"};
            `}
          >
            <Tooltip content={domain} wrapperClass={wrapperClass}>
              <AnalysisIcons
                show={show}
                imgName={domain}
                colorId={color}
              />
            </Tooltip>
          </div>
        );
      })}
    </div>
  );
};

export default PositiveList;
